import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './LeaveGamePopup.module.css';

type ReportSummaryPopup = {
  onClickLeave: () => void;
  onClickCancel: () => void;
};
export const LeaveGamePopup = ({
  onClickLeave,
  onClickCancel,
}: ReportSummaryPopup) => {
  const { t } = useTranslation();
  return (
    <BasicPopupContainer
      onPrimaryButtonClick={onClickLeave}
      primaryButtonLabel={t('Yes')}
      onSecondaryButtonClick={onClickCancel}
      secondaryButtonLabel={t('Cancel')}
    >
      <div className={styles.container}>
        <div className={styles.iconContainer}>
          {
            <SvgIcon
              name={SVGIconType.Logout}
              color={'#333'}
              width={'100%'}
              height={'100%'}
            />
          }
        </div>
        <div className={styles.titleContainer}>
          <p className={styles.title} />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.text}>
            {t('Are you sure you want to leave?')}
          </div>
        </div>
      </div>
    </BasicPopupContainer>
  );
};
